const STEP_TITLE_BY_KEY = {
  terms: 'LEE Y ACEPTA LOS TÉRMINOS Y CONDICIONES',
  credentials: 'INGRESA TUS CREDENCIALES DEL SII',
};

export default STEP_TITLE_BY_KEY;
